import { type InputHTMLAttributes, useId } from 'react';

/** Shared frame of text inputs and the select. */
export const inputFrame =
  'block min-h-11 w-full border border-line-strong bg-void px-3 text-base text-text outline-none placeholder:text-faint focus:border-accent disabled:opacity-50';

type FieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  hint?: string | undefined;
};

function Field({
  label,
  hint,
  className = '',
  inputClassName = '',
  ...props
}: FieldProps & { inputClassName?: string }) {
  const id = useId();
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="block font-display text-xs font-semibold uppercase tracking-[0.14em] text-muted"
      >
        {label}
      </label>
      <input id={id} className={`mt-1 ${inputFrame} ${inputClassName}`} {...props} />
      {hint ? <p className="mt-1 text-xs text-faint">{hint}</p> : null}
    </div>
  );
}

export function TextField({ type = 'text', ...props }: FieldProps) {
  return <Field type={type} {...props} />;
}

export function NumberField(props: Omit<FieldProps, 'type'>) {
  return (
    <Field type="number" inputMode="numeric" inputClassName="font-mono tabular-nums" {...props} />
  );
}
